import React from 'react';
import ListPageLayout from '../../ListPageLayout/ListPageLayout';
import { Filter, IFilterProps } from '../../Filter/Filter';
import { IEvent } from '../../../types/global/helper';
import { EventGrid, IEventGrid } from '../../EventComponents/EventGrid';

export interface IEventListContainer extends IFilterProps, IEventGrid {
    events: IEvent[];
    loading?: boolean;
    paginationContainer?: React.ReactNode;
}

export const EventListContainer: React.FC<IEventListContainer> = ({
    filter,
    events,
    loading,
    paginationContainer,
    ...props
}) => {
    return (
        <ListPageLayout
            RightComponent={<Filter filter={filter} {...props} />}
            TopComponent={<EventGrid events={events} {...props} />}
            BottomLeftComponent={<div />}
            CenteredBottomContainer={paginationContainer}
            BottomRightComponent={<div />}
            centerContentLoading={loading}
        />
    );
};
